import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';

/**
 * aggLogic does aggregation logic for the group row
 * @param {any} aggParentRows data table rows passed in from row group parents
 * @param {any} aggFunc custom aggregation function that will be passed in from column defs
 * @param {any} field the field to apply aggregation logic that can be reference from an individual data row
 * @returns {any}
 */

var aggLogic = function aggLogic(aggParentRows, aggFunc, field) {
  if (typeof aggFunc === 'function') {
    return {
      field: field,
      type: 'custom',
      value: aggFunc(aggParentRows, field)
    };
  } else {
    switch (aggFunc) {
      case 'sum':
        var aggSum = aggParentRows.reduce(function (acc, curr) {
          var currValue = curr[field];
          typeof currValue !== 'number' && console.warn("Hey Canvas user it looks like you may have some non numeric values in a mathematic aggregation (specifically ".concat(field, "-").concat(currValue, "). This may cause inaccurate results please check your data set"));
          return acc + Number(curr[field]);
        }, 0);
        return {
          field: field,
          type: 'sum',
          value: aggSum
        };
      case 'min':
        //user will get NaN if non number in data
        var aggMin = Math.min.apply(Math, _toConsumableArray(aggParentRows.map(function (record) {
          return record[field];
        })));
        return {
          field: field,
          type: 'min',
          value: aggMin
        };
      case 'max':
        //user will get NaN if non number in data
        var aggMax = Math.max.apply(Math, _toConsumableArray(aggParentRows.map(function (record) {
          return record[field];
        })));
        return {
          field: field,
          type: 'max',
          value: aggMax
        };
      case 'count':
        var aggCount = aggParentRows.length;
        return {
          field: field,
          type: 'count',
          value: aggCount
        };
    }
  }
  return null;
};

export { aggLogic };
